module.exports = __webpack_public_path__ + "img/planner.e1ee5a57.svg";